import React from 'react';
import { Link } from 'react-router-dom';
type Props = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  inverted?: boolean;
};
// Renders L6 — Refined Wordmark — the active site logo.
// SVG-based for precise dot placement at x-height and tuned kerning.
const SIZES = {
  sm: 22,
  md: 28,
  lg: 36
};
export function Logo({
  className = '',
  size = 'md',
  inverted = false
}: Props) {
  const px = SIZES[size];
  const fg = inverted ? '#FAF8F2' : '#0F1410';
  return <Link to="/" className={`inline-flex items-center group ${className}`} aria-label="peptides.ml home" data-id="element-399">
      <svg viewBox="0 0 240 40" style={{
      height: px * 1.05,
      width: 'auto',
      display: 'block'
    }} aria-hidden data-id="element-400">
        <defs data-id="element-401">
          <style data-id="element-402">{`
            .mp-logo-word {
              font-family: 'Geist', system-ui, -apple-system, sans-serif;
              font-weight: 500;
              letter-spacing: -1.5px;
            }
          `}</style>
        </defs>

        {/* peptides */}
        <text x="0" y="30" className="mp-logo-word" fontSize="36" fill={fg} data-id="element-403">
          peptides
        </text>

        {/* Primary-green dot — replaces the typeset period */}
        <circle cx="142" cy="26" r="3.6" className="fill-primary" data-id="element-404" />

        {/* ml */}
        <text x="150" y="30" className="mp-logo-word" fontSize="36" fill={fg} data-id="element-405">
          ml
        </text>
      </svg>
    </Link>;
}